import { useEffect } from 'react';
import type { FontValue } from '@elfsight/configurator-contracts';

export function useFontsLoader(fonts: FontValue[] = []) {
  const fontsString = fonts
    .filter(Boolean)
    .filter((item) => item.googleFont && item.value)
    .map((item) => item.value + ':400,b,i')
    .join('|');

  return useEffect(() => {
    if (!fontsString) return;

    const element = document.createElement('link');

    element.rel = 'stylesheet';
    element.href = `https://fonts.googleapis.com/css?family=${fontsString}`;

    document.head.appendChild(element);

    return () => {
      document.head.removeChild(element);
    };
  }, [fontsString]);
}
